import type { Table } from "@tanstack/react-table";
import { DataTableViewOptions } from "./view-options";
import { Input } from "@/components/ui/input";

type DataTableToolbarProps<TData> = {
  table: Table<TData>;
  searchPlaceholder?: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
};

export function DataTableToolbar<TData>({
  table,
  searchPlaceholder = "搜索…",
  searchValue,
  onSearchChange,
}: DataTableToolbarProps<TData>) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input
        value={searchValue}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={searchPlaceholder}
        className="h-8 w-full max-w-xs"
      />
      <DataTableViewOptions table={table} />
    </div>
  );
}
